import React, { useState, useEffect } from "react";

const GradientTextWithStroke = ({
  text = "Play The Games and Explore More Adventures",
  desktopFontSize = 25,
  mobileFontSize = 20,
  strokeColor = "#5c2d06",
  strokeWidth = 4,
  gradientStops = [
    { offset: "25%", color: "#FAECA4" },
    { offset: "100%", color: "#B5763A" },
  ],
  maxCharsPerLine = 20,
}) => {
  const [fontSize, setFontSize] = useState(desktopFontSize);
  const [lines, setLines] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      const currentFontSize = isMobile ? mobileFontSize : desktopFontSize;
      setFontSize(currentFontSize);

      const words = text.split(" ");
      const wrappedLines = [];
      let currentLine = "";

      words.forEach((word) => {
        if ((currentLine + " " + word).trim().length <= maxCharsPerLine) {
          currentLine += (currentLine ? " " : "") + word;
        } else {
          wrappedLines.push(currentLine);
          currentLine = word;
        }
      });

      if (currentLine) wrappedLines.push(currentLine);
      setLines(wrappedLines);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [text, desktopFontSize, mobileFontSize, maxCharsPerLine]);

  return (
    <svg
      width="100%"
      height={fontSize * (lines.length + 1)}
      viewBox={`0 0 700 ${fontSize * (lines.length + 1)}`}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMid meet"
    >
   <defs>
  <linearGradient
    id="textGradient"
    x1="0"
    y1="0"
    x2="700"
    y2="0"
    gradientUnits="userSpaceOnUse"
  >
    {gradientStops.map(({ offset, color }, idx) => (
      <stop key={idx} offset={offset} stopColor={color} />
    ))}
  </linearGradient>
</defs>



     <text
  x="50%"
  y={fontSize}
  textAnchor="middle"
  fontFamily="'Barlow', sans-serif"
  fontSize={fontSize}
  fontWeight="600"
  paintOrder="stroke fill"
>
  {lines.map((line, idx) => (
    <tspan
      key={idx}
      x="50%"
      dy={idx === 0 ? 0 : fontSize * 1.2}
      fill="url(#textGradient)"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
    >
      {line}
    </tspan>
  ))}
</text>

    </svg>
  );
};

export default GradientTextWithStroke;
